/** @jsxImportSource @emotion/react */
"use client";
import { spacing } from "../../../../../global/emotion";
import { IconButton } from "../../../_base/_core/IconButton/IconButton.emotion";
import { InfoIcon } from "../../../_base/icons/Icon/GeneralIcons";
import type { CreateDialogProps } from "../../../_base/modals/Dialog/Dialog.emotion";
import { useDialog } from "../../../_base/modals/Dialog/Dialog.emotion";

export type InfoDialogProps = CreateDialogProps<any> & {
  /** Accessible name for the icon-only trigger button. */
  ariaLabel?: string;
};

export const InfoDialog = ({ ariaLabel, ...props }: InfoDialogProps) => {
  const dialog = useDialog({
    showCloseButton: false,
    size: "m",
    ...props,
  });

  return (
    <IconButton
      aria-label={ariaLabel}
      type={"button"}
      onClick={async () => await dialog.show()}
      icon={<InfoIcon size={20} />}
      size="s"
      variant="transparentNeutral"
      css={{
        padding: spacing.xs,
      }}
    />
  );
};
